module.exports = __webpack_public_path__ + "media/images/static/top/local/cta_btn_right-3c8f21de79c960c089cada7d05d3e545.png";